import apiClient from './api';

export interface TaxSettings {
  enabled: boolean;
  rate: number;
  name: string;
  description: string;
}

export interface ShippingSettings {
  freeShippingThreshold: number;
  baseCost: number;
  perItemCost: number;
}

export interface GeneralSettings {
  siteName: string;
  currency: string;
  timezone: string;
  maintenanceMode: boolean;
}

export interface SystemSettings {
  _id: string;
  taxSettings: TaxSettings;
  shippingSettings: ShippingSettings;
  generalSettings: GeneralSettings;
  lastUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SystemSettingsUpdate {
  taxSettings?: Partial<TaxSettings>;
  shippingSettings?: Partial<ShippingSettings>;
  generalSettings?: Partial<GeneralSettings>;
}

class SystemSettingsService {
  // Obtener configuración del sistema (admin)
  async getSystemSettings(): Promise<SystemSettings> {
    const response = await apiClient.get('/admin/system-settings');
    return response.data.data;
  }

  // Actualizar configuración del sistema (admin)
  async updateSystemSettings(updates: SystemSettingsUpdate): Promise<SystemSettings> {
    const response = await apiClient.put('/admin/system-settings', updates);
    return response.data.data;
  }

  // Obtener solo configuración de impuestos (público)
  async getTaxSettings(): Promise<TaxSettings> {
    const response = await apiClient.get('/system-settings/tax');
    return response.data.data.taxSettings;
  }

  // Métodos de utilidad
  formatTaxRate(rate: number): string {
    return `${(rate * 100).toFixed(1)}%`;
  }

  calculateTax(amount: number, taxSettings: TaxSettings): number {
    if (!taxSettings.enabled) return 0;
    return amount * taxSettings.rate;
  }

  formatCurrency(amount: number, currency: string = 'USD'): string {
    const symbols: Record<string, string> = {
      HNL: 'L',
      USD: '$',
      PAB: 'B/.'
    };
    
    return `${symbols[currency] || currency} ${amount.toFixed(2)}`;
  }
}

export default new SystemSettingsService();